module.exports = __webpack_public_path__ + "img/seguridad.7f1c8aac.svg";